export const CategoryModelModule = angular
    .module('app.services.model.models.category', [])
    .value('categoryModel', {
        categoryId: 'Number',
        name: 'String',
        seo: {
            title: 'String',
            metaDescription: 'String',
            friendlyName: 'String'
        },
        contentPageId: ['String', null],
        descriptions: {
            long: 'String',
            short: 'String',
            extended: 'String'
        },
        state: ['String', 'Active'],
        parentId: 'String',
        isInMenu: 'Boolean',
        images: 'Array',
        productIds: 'Array',
        productCount: 'Number',
        subCategories: 'Array'
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/models/category.model.js